export function assetsPath(projecte: string, asset: string): string {
	let basePath = 'https://'
	switch (process.env.VERCEL_ENV) {
		case 'production':
			basePath += `${process.env.VERCEL_PROJECT_PRODUCTION_URL}/assets`
			break
		case 'development':
		case 'preview':
			basePath += `${process.env.VERCEL_URL}/assets`
			break
		default:
			basePath = 'http://localhost:5000'
			break
	}

	return `${basePath}/${projecte}/${asset}`
}

export const netejaNumero = (num: string | number) => Number(num.toString().replaceAll('.', '').replaceAll(',', ''))
export const formatNumeric = (premi: string | number) => {
	if (!premi || premi === '' || premi === '0') return ''
	return new Intl.NumberFormat('ca-ES').format(netejaNumero(premi))
}
export const formatValor = (num: number, decimals: number = 2) => {
	return new Intl.NumberFormat('ca-ES', {
		style: 'decimal',
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	}).format(num)
}
